import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React from 'react';

export function withRouter<P extends object>(Component: React.ComponentType<P>) {
    function ComponentWithRouterProp(props: any) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <Component {...props} location={location} params={params} navigate={navigate} />;
    }

    return ComponentWithRouterProp;
}
